<template>
    <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="手机号：">
            <el-input v-model="formInline.phoneNumber" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="车牌号：">
            <el-input v-model="formInline.license" placeholder="请输入车牌号"></el-input>
        </el-form-item>
        <el-form-item>
        <el-button type="primary" @click="getList(true)">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="用户手机号" width="150">
          <template #default="scope">
            <div>
              <span>{{ scope.row.phoneNumber }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="车牌号" width="130">
          <template #default="scope">
            <div>
              <span>{{ scope.row.license || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="品牌" show-overflow-tooltip>
          <template #default="scope">
            <div>
              <span>{{ scope.row.brand || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="型号" show-overflow-tooltip>
          <template #default="scope">
            <div>
              <span>{{ scope.row.model || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="用途" width="200" show-overflow-tooltip>
          <template #default="scope">
            <div>
              <span>{{ scope.row.useTypeStr || '--' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="scope">
            <el-button size="small" @click="handleEdit(scope.$index, scope.row)">
              编辑
            </el-button>
            <el-button
              size="small"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <Pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
  
      <!-- 对话框--新建、编辑组织 -->
      <el-dialog v-model="dialogFormVisible" :title="dialogTitle" width="500" :close-on-click-modal="false" @closed="$refs.addFormRef?.clearValidate()">
          <el-form ref="addFormRef" label-position="right" label-width="auto" :model="addInfo" :rules="addRules">
          <el-form-item label="车牌号" prop="license">
            <el-input v-model="addInfo.license" autocomplete="off" />
          </el-form-item>
          <el-form-item label="品牌" prop="brand">
            <el-input v-model="addInfo.brand" autocomplete="off" />
          </el-form-item>
          <el-form-item label="型号" prop="model">
            <el-input v-model="addInfo.model" autocomplete="off" />
          </el-form-item>
          <el-form-item label="用途" prop="useType">
            <el-select v-model="addInfo.useType" placeholder="请选择">
              <el-option
                  v-for="item in typeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
          </el-form>
          <template #footer>
          <div class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取消</el-button>
              <el-button type="primary" @click="saveInfo()">确定</el-button>
          </div>
          </template>
      </el-dialog>
  
      <!-- 对话框--删除 -->
      <el-dialog
        v-model="centerDialogVisible"
        title="提示"
        width="500"
        align-center
      >
        <span>确定删除该车辆吗？</span>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="deleteVehicle()">确定</el-button>
          </div>
        </template>
      </el-dialog>
  
    </template>
    
    <script>
    import { required, noSpecialChar } from '@/utils/validators';
    export default {
    name:'VehicleManage',
    data() {
      return {
        formInline:{
            phoneNumber:'',
            license:'',
        },
        selectedRoles: [],
        typeList:[
          {
            label:'未知',
            value:0
          },
          {
            label:'私家车',
            value:1
          },
          {
            label:'出租车',
            value:2
          },
          {
            label:'公交车',
            value:3
          },
          {
            label:'公务车',
            value:4
          },
          {
            label:'班车',
            value:5
          },
          {
            label:'旅游巴士',
            value:6
          },
          {
            label:'租赁用车',
            value:7
          },
          {
            label:'共享汽车',
            value:8
          },
        //   {
        //     label:'网约车',
        //     value:9
        //   }
        ],
        isUpdate:false,
        dialogTitle:'',
        dialogFormVisible:false,
        centerDialogVisible:false,
        currt_id:'', //当前操作id
        tableData:[],
        addFormRef: null,
        addRules: {
          license: [required('请输入车牌号'), noSpecialChar('车牌号不能包含特殊字符')],
          brand: [required('请输入品牌')],
          model: [required('请输入型号')],
          useType: [required('请选择用途')],
        },
        addInfo:{
          name:'',
          type:'',
          username:'',
          account:'',
          bankOf:'',
          date:[],
          time:'',
        },
        total: 0, //总条数
        currentPage: 1, //当前页
        pageSize: 10, //每页显示条数
      }
    },
    components: {
      
    },
    computed: {
      filteredMessage() {
        // 这里可以实现类似过滤器的转换逻辑
      }
    },
    beforeCreate(){
      
    },
    created(){
      
    },
    mounted(){
      this.getList(false);
    },
    methods:{
      handleSizeChange (val) { //每页显示条数
          this.pageSize = val;
          this.currentPage = 1;
          this.getList(false);
      },
      handleCurrentChange(val) { //当前页
          this.currentPage = val;
          this.getList(false); //获取列表
      },
      getList(isSearch){
        if(isSearch){
          this.currentPage = 1;
        }
        //获取列表
        let that = this;
        let param = {};
        param.page = this.currentPage;
        param.pageSize = this.pageSize;
        param.license = that.formInline.license;
        param.phoneNumber = that.formInline.phoneNumber;
        that.$axios.post(that.$store.state.platformApi+"vehicle/page",JSON.stringify(param)).then(result => {
          if(result.code==200){
            that.tableData = result.data.records;
            that.total = result.data.total;
          }
        })
      },
      saveInfo(){
        //保存
        let that = this;
        // 表单校验
        this.$refs.addFormRef.validate((valid) => {
          if (!valid) return;
          let param = {};
          var url = that.$store.state.platformApi+"vehicle/update";
          param = this.addInfo;
          that.$axios.post(url,JSON.stringify(param)).then(result => {
            if(result.code==200){
              // 保存成功
              that.dialogFormVisible = false;
              that.getList(false);
            }
          });
        });
      },
      handleEdit(index,row){
        //打开编辑
        this.dialogTitle = '编辑车辆';
        this.isUpdate = true;
        this.dialogFormVisible = true;
        this.addInfo = JSON.parse(JSON.stringify(row));
      },
      deleteVehicle(){
        //删除车辆
        let that = this;
        that.$axios.post(that.$store.state.platformApi+"vehicle/del",JSON.stringify({id:that.currt_id})).then(result => {
          if(result.code==200){
            // 删除成功
            that.$message({
              message: '删除成功',
              type: 'success'
            });
            that.centerDialogVisible = false;
            that.getList(false);
          }
        });
      },
      handleDelete(index,row){
          //删除弹窗
        this.centerDialogVisible = true;
        this.currt_id = row.id;
      },
      typeFilter(value) {
        //过滤函数
        switch (value) {
          case 1:
            return '私家车';
          case 2:
            return '出租车';
          case 3:
            return '公交车';
          case 4:
            return '私家车';
          case 5:
            return '班车';
          case 6:
            return '旅游巴士';
          case 7:
            return '租赁用车';
          case 8:
            return '共享汽车';
          default:
            return '未知';
        }
      },
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .search_nav{
      width: 100%;
      height: 60px;
  }
  </style>